import angular from 'angular'

import component from './help-block.component'

let module = angular.module('helpBlockModule', [])

.component('helpBlock', component)

.name

export default module



// WEBPACK FOOTER //
// ./src/app/common/help-block/index.js